"use client";

import { motion, AnimatePresence } from "framer-motion";
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useMegaMenu } from "./MegaMenuContext";
import { MegaMenuCTA } from "./MegaMenuCTA";
import { MegaMenuLinks } from "./MegaMenuLinks";
import { MegaMenuServicesLayout } from "./MegaMenuServicesLayout";

export function MegaMenu() {
  const { activeDropdown, activeDropdownData, setActiveDropdown, cancelClose } = useMegaMenu();
  const handleNavigate = () => setActiveDropdown(null);

  // Determine if we should show the mega menu
  const isServicesLayout = activeDropdownData?.megaMenuType === "services-layout";
  const hasServicesColumns = isServicesLayout && activeDropdownData?.servicesLayout?.columns && activeDropdownData.servicesLayout.columns.length > 0;
  const hasStandardContent = !isServicesLayout && activeDropdownData?.children && activeDropdownData.children.length > 0;
  const shouldShow = activeDropdown && (hasStandardContent || hasServicesColumns);

  return (
    <AnimatePresence mode="wait">
      {shouldShow && (
        <motion.div
          initial={{ height: 0, opacity: 0, marginTop: 0 }}
          animate={{ height: "auto", opacity: 1, marginTop: 8 }}
          exit={{ height: 0, opacity: 0, marginTop: 0 }}
          transition={{
            duration: 0.3,
            ease: "easeInOut",
            opacity: { duration: 0.2 }
          }}
          style={{ overflow: "hidden" }}
          onMouseEnter={cancelClose}
          onMouseLeave={() => setActiveDropdown(null)}
        >
          <div className="bg-white/95 rounded-[10px] shadow-lg backdrop-blur-md overflow-hidden">
            {isServicesLayout ? (
              // Services layout: manual columns
              <MegaMenuServicesLayout
                columns={activeDropdownData?.servicesLayout?.columns}
                onNavigate={handleNavigate}
              />
            ) : (
              // Standard layout: CTA + Links
              <div className="flex">
                {/* Left: CTA Area (~35%) */}
                <div className="w-[35%] min-w-[280px]">
                  <MegaMenuCTA config={activeDropdownData?.megaMenuCTA} onNavigate={handleNavigate} />
                </div>

                {/* Right: Navigation Links (~65%) */}
                <div className="flex-1 border-l border-gray-100">
                  <MegaMenuLinks items={activeDropdownData?.children || []} onNavigate={handleNavigate} />
                </div>
              </div>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
